export default class SendKeypadDigits {
  constructor(context) {
    this.context = context;
  }

  run(digits) {
    this.context.gateways.phoneGateway.sendDigits(digits);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/send_keypad_digits.js